<template>
  <div
    :class="[
      'topnav-product-line-container',
      { 'four-items': itemsArray.length === 4 }
    ]"
  >
    <a
      v-for="item in itemsArray"
      :key="item.image"
      :href="item.link"
      class="product-line"
    >
      <img
        class="product-image"
        :src="item.image"
        :alt="item.alt"
        aspect-ratio="1"
        contain
      />
      <div class="product-text">
        <h6 class="product-title">
          <span v-html="item.text" />
        </h6>
        <p class="product-description" v-html="item.desc" />
      </div>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import VueMq from "vue-mq";

import { ConfigService } from "@nuskin/ns-util";

import { getImagesFromJson } from "../utils/helpers";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

const nsTopnavProductLine = {
  name: "NsTopnavProductLine",
  props: {
    /**
     * Product items (max: 3)
     * [{image, alt, text, link, desc}]
     */
    items: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localItems: []
    };
  },
  computed: {
    itemsArray() {
      const marketConfig = ConfigService.getMarketConfig();
      return (getImagesFromJson(marketConfig.siteUrl, this.items) || []).filter(
        item => item.image || item.text
      );
    }
  }
};

export default nsTopnavProductLine;
</script>

<style lang="scss" scoped>
@import "~@nuskin/ns-core-styles/src/scss/_global.mixins";
@import "~@nuskin/ns-core-styles/src/scss/globalVariables";

.topnav-product-line-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  padding: 60px 20px;

  &.four-items {
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
  }
}

.product-line {
  display: flex;
  justify-content: center;
  text-decoration: none;
  &:hover .product-title span {
    border-bottom: 1px solid currentColor;
  }
}

.product-image {
  flex: 1 0 0;
  display: block;
  margin-right: 15px;
  max-height: 200px;
  min-height: 100px;
  max-width: 200px;
  min-width: 100px;
  object-fit: contain;
}

.product-text {
  max-width: 200px;
  min-width: 100px;
  flex: 1 0 0;
}

.product-title {
  display: inline-block;
  margin-top: 22.5%;
  margin-bottom: 14px;
  color: rgb(39, 37, 37);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: normal;

  span {
    border-bottom: 1px solid transparent;
    line-height: 22px;
  }
}

.product-description {
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 18px;
}

@media (max-width: 1023px) {
  .topnav-product-line-container {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 0px;
    padding: 0 20px 20px;

    &.four-items {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  .product-line {
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
  }

  .product-image {
    min-height: 200px;
    min-width: 200px;
  }

  .product-title {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
